import { useSelector } from 'react-redux';
import cn from 'classnames';
import { rm } from 'utils';
import { Button } from 'components/Button';
import { IconPlus } from 'components/Shared/Icon';
import { isMobile } from '../responsive';
import Drawer, { OwnProps as DrawerProps } from './';
import styles from './redDrawer.scss';

interface Props extends DrawerProps {
  title?: string;
  closeText?: string;
  onClose?: () => void;
  noPadding?: boolean;
  noCloseButton?: true;
}

export const RedDrawer = ({
  className,
  title,
  children,
  closeText,
  noPadding = false,
  noCloseButton,
  side = 'right',
  ...props
}: Props) => {
  const isPhone = useSelector(isMobile);

  return (
    <Drawer
      className={cn(styles.drawer, className)}
      side={side}
      width={isPhone ? 'full' : 'default'}
      {...props}
    >
      {title && <h3 className={styles.header}>{title}</h3>}

      <div className={cn(styles.body, { [styles.noPadding]: noPadding })}>{children}</div>

      {!noCloseButton && (
        <div className={styles.footer}>
          <Button onClick={props.onClose} appearance="tertiary" className={styles.closeButton}>
            <IconPlus appearance="flip-45" size="small" />
            <span className={styles.closeText}>
              {closeText || rm('red_drawer_default_close_text')}
            </span>
          </Button>
        </div>
      )}
    </Drawer>
  );
};
